import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { IconButton, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { TimesCaptcha } from './Utility';
import { getCaptcha } from './Services';
import { useStyles } from './Style';
import { Icons } from 'components';

const CustomCaptchaComponent = forwardRef((props, ref) => {
  const {
    setCaptchaId,
    setEnteredCaptcha,
    duration = 'DEFAULT_TIME',
    sizeOptions = {
      xs: '12',
      md: '4',
      lg: '3',
    },
    customClasses = null,
    pageTitle = '',
  } = props;
  const classes = useStyles();
  const [captchaImg, setCaptchaImg] = useState(null);
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const [captchaTimeInterval, setCaptchaTimeInterval] = useState(
    Number(JSON.parse(JSON.stringify(TimesCaptcha[duration]))),
  );
  // const [captchaId, setCaptchaId] = useState(null);

  useEffect(() => {
    //logTest();
    if (captchaTimeInterval == 0) {
      makeCaptcha();
    }
  }, [captchaTimeInterval]);

  useEffect(() => {
    makeCaptcha();
    const interval = setInterval(() => {
      if (captchaTimeInterval != 0) {
        setCaptchaTimeInterval((prevCount) => prevCount - 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  // --API--//
  const makeCaptcha = async () => {
    setCaptchaLoading(true);
    setEnteredCaptcha('');
    try {
      const r = await getCaptcha();
      setCaptchaTimeInterval(Number(JSON.parse(JSON.stringify(TimesCaptcha[duration]))));
      setCaptchaId(r?.result?.captchaId);
      setCaptchaImg(r?.result?.captchaImg);

      setCaptchaLoading(false);
    } catch (error) {
      setCaptchaLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    onMakeCaptcha() {
      makeCaptcha();
    },
  }));

  return (
    <>
      <Grid
        className={customClasses?.captchaBoxClass ? customClasses?.captchaBoxClass : {}}
        container
        alignItems="flex-end"
        {...sizeOptions}
      >
        <Grid item >
          {!captchaLoading && captchaImg ? (
            <img
              alt="captcha"
              src={'data:image/png;base64,' + captchaImg}
              className={
                customClasses?.captchaImgClass ? customClasses?.captchaImgClass : classes.captcha
              }
            />
          ) : (
            <Skeleton
              variant="text"
              className={
                customClasses?.captchaLoadingClass
                  ? customClasses?.captchaLoadingClass
                  : classes.captchaLoading
              }
            />
          )}
        </Grid>
        <Grid
          item
          className={
            customClasses?.iconActionClass ? customClasses?.iconActionClass : classes.iconAction
          }
        >
          <IconButton
            tabIndex={-1}
            onClick={() => {
              !captchaLoading && makeCaptcha();
            }}
            size="large">
            <Icons icon="Refresh" color="#b5b5b5" size="18" />
          </IconButton>
        </Grid>
      </Grid>
    </>
  );
});

export default CustomCaptchaComponent;
